(ns ycweb.app.website.myaccount.aftersales.complete
  (:require
   [rum.core :as rum]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc aftersale-complete < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        return-case (cmn/curact process-atom [:return-case])]
    [:div.dashboard
     (headings/heading "Request received" {:type :h2 :size :medium})
     [:div.u-max-width-640
      (feedback/feedback :info (str "Your reference number is: " (:ent/display-name return-case)) "")
      [:p.yc-paragraph
       "You'll receive an auto response email confirming your request and our customer service team will
       review your case and be in touch with you."]
      [:p.yc-paragraph
       "Remember to ensure that you have packed the item in its original packaging (If necessary) AND in another
        box with as much padding and protective packaging as possible. Write this YCR reference
        (" (:ent/display-name return-case) ") on the outside of box."]]
     [:div.button-group {:class (u/bem :button-wrapper [:section])}]
     [:div {:class (u/bem :flex-grid-group [:align-left :flush])}
      [:div {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Back to dashboard"
          (merge (urlstate/href-props app-atom "myaccount")
            {:style :primary
             :size :default}))]]
      [:div {:class (u/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button-web "Start shopping"
          {:href "/index.htm"
           :style :secondary
           :size :default})]]]]))

(defmethod flow/render-screen :web.myaccount/aftersale-complete [app-atom _]
  (awm.common/screen-wrapper app-atom
    (aftersale-complete app-atom)))
